module.exports = __webpack_public_path__ + "static/media/heroGraphic800.23e08b4f.png";